import { useIntl } from 'react-intl'

import IntlFormattedDate from 'app/i18n/IntlFormattedDate'
import { DASH_SYMBOL } from 'app/consts'
import CopyCode from 'features/licenses/components/LicensesGroupsTable/CopyCode'
import { LicenseType } from 'features/licenses/types'
import MobileLabelLine from 'components/MobileWhiteCardLine'
import { HomeLicensesMobileContainer } from '../../../styles'
import { homeLicensingMessages } from '../../../messages'
import ApplyLicense from '../ApplyLicense'
import AvailableLicenseNote from '../AvailableLicenseNote'
import { HomeLicensesCopyCode } from './styles'

interface HomeLicensesGroupMobileProps {
  values: Record<string, any>
  original: LicenseType
}

function HomeLicensesGroupMobile({
  values,
  original,
}: HomeLicensesGroupMobileProps) {
  const { formatMessage } = useIntl()

  return (
    <HomeLicensesMobileContainer>
      <HomeLicensesCopyCode>
        <CopyCode code={original.code} />
        <ApplyLicense original={original} />
      </HomeLicensesCopyCode>
      <MobileLabelLine
        label={formatMessage(homeLicensingMessages.orderNumber)}
        value={values.orderNumber}
      />
      <MobileLabelLine
        label={formatMessage(homeLicensingMessages.purchaseOrder)}
        value={values.customerPO}
      />
      <MobileLabelLine
        label={formatMessage(homeLicensingMessages.created)}
        value={
          <IntlFormattedDate
            date={values.created}
            withTime
            defaultReturn={DASH_SYMBOL}
          />
        }
      />
      <AvailableLicenseNote original={original} initialNote={values.notes} />
    </HomeLicensesMobileContainer>
  )
}

export default HomeLicensesGroupMobile
